module.exports = __webpack_public_path__ + "img/0-02-0a-4f46c98dfffb70f0d31f4e6444daff0426f335f77f3fb822ce9a383bf02a4cff_ebfa5684.3de03676.jpg";